<script>
  import { onMount } from 'svelte'; // Importar onMount
  import Conexoes from '../Classes/Conexoes.js';
  import Constantes from '../Classes/Constantes.js';
  import { tenantLogado } from '../Classes/Stores.js';
  import { navigate } from 'svelte-routing';
  import LoadingTela from '../componentes_basicos/LoadingTela.svelte';
  import CaixaDeDialogo from '../componentes_basicos/CaixaDeDialogo.svelte';

  let email = '';
  let senha = '';
  let isLoading = false;
  let mensagem = ''; 
  let modoRecuperacao = false;

  const conexao = new Conexoes();

  // NOVO: Auto-redirect se já estiver logado
  onMount(() => {
    const usuarioLogado = localStorage.getItem('usuarioLogado');
    if (usuarioLogado) {
      navigate(Constantes.tela_painel);
    }
  });

  async function handleLogin() {
    if (!email || !senha) {
      mensagem = Constantes.msg_campos_obrigatorios;
      return;
    }
    isLoading = true;
    const resposta = await conexao.conecta(Constantes.api_acesso, { body: { email, senha } });
    isLoading = false;

    if (resposta?.sucesso) {
      // Salva tanto no Store quanto no localStorage para persistência
      tenantLogado.set(resposta.tenant);
      localStorage.setItem('usuarioLogado', JSON.stringify(resposta.tenant));
      navigate(Constantes.tela_painel);
    } else {
      mensagem = resposta?.mensagem || 'E-mail ou senha inválidos.';
    }
  }

  async function handleRecuperacao() {
    if (!email) {
      mensagem = 'Por favor, insira o seu e-mail para recuperar a senha.';
      return;
    }
    isLoading = true;
    const url = Constantes.api_acesso.replace('acesso.php', 'esqueci_senha.php');
    const resposta = await conexao.conecta(url, { body: { email } });
    isLoading = false;
    mensagem = resposta?.mensagem || 'Processando solicitação...';
    if (resposta?.sucesso) {
      modoRecuperacao = false;
      senha = ''; 
    }
  }
</script>



<svelte:head>
  <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800&display=swap" rel="stylesheet">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css">
</svelte:head>

<LoadingTela {isLoading} />
<CaixaDeDialogo message={mensagem} button1Label="Ok" button1Action={() => mensagem = ''} />

<div class="login-wrapper">
  
  <div class="brand-area fade-in">
    <div class="brand-area fade-in">
    <div class="logo-badge">
    <img src="img/logo2.png" alt="Hora na mão" class="logo-badge-img" />
  </div>
  <br>
  <div class="brand-text-block">
   <h1 class="brand-subtitle">Hora na mão</h1>
    <h3>Sistema de Agendamentos</h3>
   
    <p>Sua agenda em 3 cliques</p>
  </div>
  </div>

  </div>

  <div class="login-card fade-in">
    <h3>{modoRecuperacao ? 'Recuperar Senha' : 'Entrar'}</h3>
    <p class="subtitle">
      {#if modoRecuperacao}
        Enviaremos um link seguro para o seu e-mail.
      {:else}
        Insira suas credenciais para continuar.
      {/if}
    </p>

    <form on:submit|preventDefault={modoRecuperacao ? handleRecuperacao : handleLogin}>
      
      <div class="field-group">
        <label for="email">E-mail</label>
        <div class="input-icon">
          <i class="far fa-envelope"></i>
          <input type="email" id="email" class="input-modern" bind:value={email} placeholder="seu@email.com" required />
        </div>
      </div>

      {#if !modoRecuperacao}
        <div class="field-group fade-in">
          <div class="label-flex">
            <label for="senha">Senha</label>
            <button type="button" class="btn-link" on:click={() => modoRecuperacao = true}>Esqueci a senha?</button>
          </div>
          <div class="input-icon">
            <i class="fas fa-lock"></i>
            <input type="password" id="senha" class="input-modern" bind:value={senha} placeholder="••••••••" required />
          </div>
        </div>
        
        <button type="submit" class="btn-primary w-100">
          Acessar Painel <i class="fas fa-sign-in-alt ms-2"></i>
        </button>
      
      {:else}
        <div class="fade-in">
          <button type="submit" class="btn-primary w-100" style="background: var(--accent);">
            Enviar E-mail de Recuperação <i class="fas fa-paper-plane ms-2"></i>
          </button>
          
          <button type="button" class="btn-outline w-100 mt-3" on:click={() => modoRecuperacao = false}>
            <i class="fas fa-arrow-left me-2"></i> Voltar para o Login
          </button>
        </div>
      {/if}

    </form>
  </div>

  <div class="footer-links fade-in">
    <p>Ainda não automatizou sua agenda? <a href="/">Conheça os planos</a></p>
  </div>
</div>

<style>
  :root {
    --primary: #4a6c56;
    --primary-dark: #3a5443;
    --secondary: #d4e0d7;
    --accent: #cfaa6c;
    --accent-hover: #b8955a;
    --text-main: #2c3e34;
    --text-muted: #738a7c;
    --border: #e0e6e2;
  }

  * { box-sizing: border-box; }

  .login-wrapper {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, var(--primary) 0%, #2c3e34 100%);
    font-family: 'Montserrat', sans-serif;
    padding: 20px;
  }

  .brand-area { text-align: center; color: white; margin-bottom: 30px; }

  .logo-placeholder {
    width: 60px; height: 60px;
    background: var(--accent); color: white;
    border-radius: 16px; display: flex; align-items: center; justify-content: center;
    font-size: 1.8rem; margin: 0 auto 15px auto;
    box-shadow: 0 4px 15px rgba(207, 170, 108, 0.4);
    transform: rotate(10deg);
  }

  .brand-area h1 { margin: 0; font-size: 1.5rem; font-weight: 800; letter-spacing: 0.5px; }
  .brand-area p { margin: 5px 0 0 0; font-size: 0.95rem; opacity: 0.8; }

  .login-card {
    background: #fff; padding: 40px 35px; border-radius: 16px;
    width: 100%; max-width: 420px;
    box-shadow: 0 15px 50px rgba(0,0,0,0.3);
    border-bottom: 5px solid var(--accent);
  }

  .login-card h3 { margin: 0 0 5px 0; color: var(--primary); font-size: 1.6rem; font-weight: 800; }
  .subtitle { color: var(--text-muted); font-size: 0.9rem; margin-bottom: 30px; }

  /* Correção do Layout: field-group garante o empilhamento vertical */
  .field-group { 
    margin-bottom: 20px; 
    display: block; 
    width: 100%; 
  }
  
  .field-group label { 
    display: block; 
    font-size: 0.85rem; 
    font-weight: 700; 
    color: var(--text-main); 
    margin-bottom: 8px; 
    text-align: left;
  }
  
  .label-flex { 
    display: flex; 
    justify-content: space-between; 
    align-items: baseline; 
    margin-bottom: 8px; 
  }

  .label-flex label { 
    margin-bottom: 0; 
  }
  
  .btn-link { 
    background: none; border: none; color: var(--accent); 
    font-size: 0.8rem; font-weight: 700; cursor: pointer; padding: 0; 
  }
  .btn-link:hover { text-decoration: underline; color: var(--accent-hover); }

  .input-icon { position: relative; display: flex; align-items: center; }
  .input-icon i { position: absolute; left: 15px; color: var(--text-muted); font-size: 1rem; }

  .input-modern {
    width: 100%; padding: 14px 15px 14px 45px;
    border: 1px solid var(--border); border-radius: 8px;
    font-family: inherit; font-size: 1rem; color: var(--text-main);
    background: #fdfdfd; transition: all 0.2s;
  }
  .input-modern:focus {
    outline: none; border-color: var(--primary); background: white;
    box-shadow: 0 0 0 3px rgba(74, 108, 86, 0.1);
  }

  .w-100 { width: 100%; }
  .ms-2 { margin-left: 8px; }
  .me-2 { margin-right: 8px; }
  .mt-3 { margin-top: 15px; }

  .btn-primary {
    background: var(--primary); color: white; border: none;
    padding: 15px; border-radius: 8px; font-weight: 700; font-size: 1.05rem;
    cursor: pointer; transition: background 0.3s, transform 0.2s; margin-top: 10px;
  }
  .btn-primary:hover { background: var(--primary-dark); transform: translateY(-2px); }

  .btn-outline {
    background: transparent; color: var(--primary); border: 2px solid var(--border);
    padding: 12px; border-radius: 8px; font-weight: 700; font-size: 0.95rem;
    cursor: pointer; transition: all 0.2s;
  }
  .btn-outline:hover { background: #f4f7f5; border-color: var(--primary); }

  .footer-links { margin-top: 30px; text-align: center; color: rgba(255,255,255,0.7); font-size: 0.9rem; }
  .footer-links a { color: var(--accent); font-weight: 700; text-decoration: none; }
  .footer-links a:hover { text-decoration: underline; }

  .fade-in { animation: fadeIn 0.4s ease-in-out; }
  @keyframes fadeIn { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
/* Adicione isso ao seu <style> */
  /* === NOVO CSS PARA O BADGE DE LOGO === */
  .logo-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px; /* Espaço entre o logo e o texto */
    margin-bottom: 30px;
  }

  .logo-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #ffffff; /* Fundo branco para garantir contraste do logo original */
    padding: 15px;
    border-radius: 50%; /* Faz o crachá circular (fica muito mais elegante que quadrado) */
    box-shadow: 0 5px 15px rgba(0,0,0,0.2); /* Sombra suave para dar profundidade */
    border: 2px solid #deff9a; /* Opcional: Adicionar a borda verde do seu Capturar.jpg para integrar */
    width: 200px; /* Tamanho do círculo */
    height: 200px;
  }

  .logo-badge-img {
    max-width: 100%; /* Garante que o logo caiba dentro do círculo */
    height: auto;
  }
  .brand-subtitle {
    color: var(--accent);
    font-size: 1.8rem;
    font-weight: 800;
    margin-top: -5px;
    margin-bottom: 10px;
  }

  @media (max-width: 768px) {
    .login-wrapper {
      justify-content: flex-start;
      padding: 32px 16px;
    }

    .brand-area {
      margin-bottom: 20px;
    }

    .logo-badge {
      width: 150px;
      height: 150px;
      padding: 12px;
    }

    .brand-subtitle {
      font-size: 1.4rem;
    }

    .login-card {
      padding: 28px 20px;
      border-radius: 14px;
    }

    .label-flex {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  }

</style>